import { Image } from '@ds';
import { OrganType } from '@/api/apis/case';
import { getColorsByOrganType, getOrganImg } from '@/utils/helpers';

type OrganTypeBadgeProps = {
  organ: OrganType;
  size?: 'sm' | 'md' | 'lg';
  bgTone?: 'bg40' | 'bg50' | 'bg60';
  showBackground?: boolean;
  className?: string;
};

const sizeMap = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-7 h-7',
};

export const OrganTypeBadge = ({
  organ,
  size = 'md',
  bgTone = 'bg50',
  className = '',
  showBackground = true,
}: OrganTypeBadgeProps) => {
  const colors = getColorsByOrganType(organ);
  const bgClass = showBackground ? colors[bgTone] || colors.bg50 : '';
  const sizeClass = sizeMap[size];

  if (!showBackground) {
    return <Image src={getOrganImg(organ)} alt={`${organ} image`} className={`${sizeClass} ${className}`} />;
  }

  return (
    <div className={`rounded-full flex justify-center items-center ${sizeClass} ${bgClass} ${className}`}>
      <Image src={getOrganImg(organ)} alt={`${organ} image`} />
    </div>
  );
};
